import React, {FC, memo } from 'react';

const BookmarkIcon16: FC<{ fill: string}> = ({ fill }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.3335 14V4.11765C3.3335 2.9481 4.22893 2 5.3335 2H10.6668C11.7714 2 12.6668 2.9481 12.6668 4.11765V14L8.00016 9.50802L3.3335 14Z" stroke="#FEFEFE"/>
    </svg>
  );
}

export default memo(BookmarkIcon16);
import React, {FC, memo } from 'react';

const BookmarkIcon16: FC<{ fill: string}> = ({ fill }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.3335 14V4.11765C3.3335 2.9481 4.22893 2 5.3335 2H10.6668C11.7714 2 12.6668 2.9481 12.6668 4.11765V14L8.00016 9.50802L3.3335 14Z" stroke="#FEFEFE"/>
    </svg>
  );
}

export default memo(BookmarkIcon16);
